import {
  createManufacturerAccount,
  updateManufacturerAccount,
} from "app/services/manufacturers/manufacturers";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  MANUFACTURER_ACCOUNT_PASSWORD_MIN_LENGTH,
  TOAST_SEVERITY,
} from "static/constants";
import { showToast } from "utils/toast";

const useManufacturerAccountForm = ({
  handleClose,
  selectedManufacturerAccount,
  isUpdate,
}) => {
  const initialValues = {
    account: "",
    username: "",
    password: "",
    usergroup: "",
    isActive: true,
    manufacturer: "",
    confirmPassword: "",
  };

  const [accountList, setAccountList] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [manufacturersList, setManufacturersList] = useState([]);
  const [isConfirmPasswordValid, setIsConfirmPasswordValid] = useState(false);
  const [manufacturerAccountFormValues, setManufacturerAccountFormValues] =
    useState(initialValues);

  const { manufacturers: manufacturerList } = useSelector(
    (state) => state.manufacturers
  );

  const { accounts } = useSelector((state) => state.account);

  useEffect(() => {
    const updatedManufacturerList = manufacturerList.map(({ name }) => {
      return { value: name, label: name };
    });
    setManufacturersList(updatedManufacturerList);
  }, [manufacturerList]);

  useEffect(() => {
    const updatedAccountList = accounts.map(({ name }) => {
      return { value: name, label: name };
    });
    setAccountList(updatedAccountList);
  }, [accounts]);

  useEffect(() => {
    if (selectedManufacturerAccount) {
      const {
        _id,
        manufacturer,
        account,
        usergroup,
        username,
        isActive,
        password,
      } = selectedManufacturerAccount;

      const selectedManufacturerAccountFormValue = {
        _id,
        account,
        username,
        password,
        usergroup,
        manufacturer,
        isActive: isActive,
      };

      setManufacturerAccountFormValues(selectedManufacturerAccountFormValue);
    }
  }, [selectedManufacturerAccount]);

  const handleFormUpdate = (newValue, fieldName) => {
    setSubmitClicked(false);
    handlePasswordValidate(newValue, fieldName);
    setManufacturerAccountFormValues((prevValues) => ({
      ...prevValues,
      [fieldName]: newValue,
    }));
  };

  const handlePasswordValidate = (passwordInput, fieldName) => {
    if (fieldName === "password") {
      setIsPasswordValid(
        passwordInput.length >= MANUFACTURER_ACCOUNT_PASSWORD_MIN_LENGTH
      );
    }
    if (fieldName === "confirmPassword") {
      setIsConfirmPasswordValid(
        manufacturerAccountFormValues.password === passwordInput
      );
    }
  };

  const handleFormSubmit = async (values) => {
    try {
      setSubmitClicked(true);
      setIsProcessing(true);

      let response;
      const { confirmPassword, ...manufacturerAccountPayload } = values;

      if (isUpdate) {
        const { _id, ...payload } = manufacturerAccountPayload;
        response = await updateManufacturerAccount(_id, payload);
      } else {
        response = await createManufacturerAccount(manufacturerAccountPayload);
      }

      if (response.type === "Success") {
        showToast({ message: response.message });
        handleClose("success");
      }
    } catch (error) {
      showToast({ message: error.message, type: TOAST_SEVERITY.ERROR });
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    accountList,
    isProcessing,
    submitClicked,
    isPasswordValid,
    manufacturersList,
    isConfirmPasswordValid,
    manufacturerAccountFormValues,

    setAccountList,
    setIsProcessing,
    setSubmitClicked,
    handleFormSubmit,
    handleFormUpdate,
    setManufacturersList,
    setManufacturerAccountFormValues,
  };
};

export default useManufacturerAccountForm;
